import { Helmet } from 'react-helmet-async'

import {
  Box, Button, Columns, PageHeader,
} from '@domain-group/suit-theme'

import useTaskList from '@hooks/useTaskList'

import { generateTabBarItems } from '@sections/Admin/packs/Projects/screens/Detail/functions/generateTabBarItems'

import TaskListSections from '../TaskListSections'

interface PageContentProps {
  taskListId: number,
}

const PageContent = (props: PageContentProps) => {
  const { taskListId } = props

  const taskListPayload = useTaskList({ id: taskListId })

  const {
    taskList,
    urls: { taskListsIndexUrl },
  } = taskListPayload

  return (
    <>
      <Helmet>
        <title>Projects | Template Manager</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            as="a"
            buttonStyle="secondaryUtility"
            href={taskListsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="tasks"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateTabBarItems(taskList)}
        title="Tasks"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main marginRight="0" width="100%">
            <TaskListSections taskList={taskList} />
          </Columns.Main>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
